import { render, staticRenderFns } from "./Ones.vue?vue&type=template&id=337550a6&scoped=true"
import script from "./Ones.vue?vue&type=script&lang=js"
export * from "./Ones.vue?vue&type=script&lang=js"
import style0 from "./Ones.vue?vue&type=style&index=0&id=337550a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337550a6",
  null
  
)

export default component.exports